import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/features/auth/store';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await useAuthStore.getState().actions.checkAuth();

    const { isAuthenticated } = useAuthStore.getState();

    if (isAuthenticated) {
      // Authenticated user, redirect to projects
      throw redirect({
        to: '/projects',
      });
    } else {
      // Not authenticated, redirect to login
      throw redirect({
        to: '/auth/login',
      });
    }
  },
});
